/*
  HB 2026-10-16 (QV round 4 follow-up, fix 5.156's rule carried to the collection cards; Vic: "if it doesn't slow
  down anything else, you can copy this to elsewhere on site where it may provide a big speed boost"): a card's
  color dot used to fetch its card only on the click (a section of about 28 KB, then its picture). Now the fetch
  starts the moment a finger lands on the dot or the mouse rests on it (pointerenter / touchstart), into the same
  cache the click reads, and the new card's first picture is warmed as soon as the section is in, so the click
  finds both ready. Nothing is fetched for dots she does not touch; a dot already fetched is never fetched twice;
  the click itself is unchanged.
  HB 2026-10-21: the warm-up takes the card's first picture (it took the quick add's thumbnail before).
*/
class CardSwatch extends HTMLElement {
  static cache = new Map(); 
  static pending = new Map();

  constructor() {
    super();
    this.url = this.getAttribute("data-url");
  }

  // the card for this color, fetched once; the click waits for a fetch already on its way
  static load(url) {
    if (CardSwatch.cache.has(url)) return Promise.resolve(CardSwatch.cache.get(url));
    if (CardSwatch.pending.has(url)) return CardSwatch.pending.get(url);
    const p = fetch(url, { cache: "no-cache" })
      .then((res) => res.text())
      .then((text) => {
        const htmlDoc = new DOMParser().parseFromString(text, "text/html");
        CardSwatch.cache.set(url, htmlDoc);
        return htmlDoc;
      })
      .finally(() => CardSwatch.pending.delete(url));
    CardSwatch.pending.set(url, p);
    return p;
  }

  // ahead of the click: the card, then its first picture at the size the card shows it
  warm() {
    if (!this.url || CardSwatch.cache.has(this.url) || CardSwatch.pending.has(this.url)) return;
    CardSwatch.load(this.url)
      .then((htmlDoc) => {
        // HB 2026-10-21: the card's own first picture, the one on show (the dress or the model view). The first img in
        // the fetched card is the quick add's 72 px thumbnail, so the warm-up fetched that and the click still waited
        // for the picture.
        const view = document.documentElement.classList.contains("product-view--model") ? "model" : "dress";
        const img =
          htmlDoc.querySelector("product-card slideshow-slide img.product-view-image--" + view) ||
          htmlDoc.querySelector("product-card slideshow-slide img");
        if (!img) return;
        const im = new Image();
        if (img.getAttribute("sizes")) im.sizes = img.getAttribute("sizes");
        if (img.getAttribute("srcset")) im.srcset = img.getAttribute("srcset");
        im.src = img.getAttribute("src") || "";
      })
      .catch(() => {});
  }

  connectedCallback() {
    const warm = () => this.warm();
    this.addEventListener("pointerenter", warm, { passive: true });
    this.addEventListener("touchstart", warm, { passive: true });
    this.addEventListener("click", async (e) => {
      e.preventDefault();

      let htmlDoc;
      try {
        htmlDoc = await CardSwatch.load(this.url);
      } catch (err) {
        return;
      }

      const productContainer = this.closest("product-card");
      if(productContainer){
         const newCard = htmlDoc.querySelector("product-card");
         if (productContainer && newCard) {
           productContainer.outerHTML = newCard.outerHTML;
         }
      }
      else{
        const recentContainer = this.closest(".recently_view_item")
        const newCard = htmlDoc.querySelector(".recently_view_item");
        recentContainer.outerHTML = newCard.outerHTML;
      }

    });
  }
}

if (!customElements.get("card-swatch")) customElements.define("card-swatch", CardSwatch);
